
import moment from 'moment'
import Vue, { PropType } from 'vue'
import api from '../../api/api'

import Breadcrumbs from '../../components/Breadcrumbs.vue'
import SpinnerLoader from '../../components/SpinnerLoader.vue'
import { Connector, Project } from '../../types/main'
import { CONNECTOR_TYPES } from '../../vars/general'
import BaseInputOutlined from '../../components/inputs/BaseInputOutlined.vue'
import CustomActivatorSelect from '../../components/inputs/CustomActivatorSelect.vue'
import pickBy from 'lodash/pickBy'
import isObject from 'lodash/isObject'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import first from 'lodash/first'
import setWith from 'lodash/setWith'
import LineChart from '@root/src/components/charts/LineChart'
export default Vue.extend({
    name: 'GCB2MarketingReport',
    components: {
        Breadcrumbs,
        SpinnerLoader,
        CustomActivatorSelect,
        BaseInputOutlined,
        LineChart
    },

    data: () => ({
        pageLoading: false,
        dashboardDataLoading: false,
        dateMenu: false,
        dateMenuForGraphs: false,
        dates: [] as string[],
        datesForGraphs: [] as string[],
        staffNames: [] as string[],
        staffNamesList: [] as string[],
        dateFormat: 'DD.MM.YYYY',
        datePickerDateFormat: 'YYYY-MM-DD',
        dateHasChanged: false,
        dateForGraphsHasChanged: false,
        filters: {} as any,
        filtersLists: {} as any,
        inititalFilters: {} as any,
        firstInited: false,
        hideNetworkColumn: false,
        valuesKeys: [
            {
                name: 'Оборот',
                key: 'revenue',
                isPercent: false,
                hintText: 'Выручка за товары и услуги в указанном промежутке (с учетом всех скидок).',
            },
            {
                name: 'Оборот услуги',
                key: 'revenue_services',
                isPercent: false,
                hintText: 'Выручка за услуги в указанном промежутке (с учетом всех скидок).',
            },
            {
                name: 'Оборот товары',
                key: 'revenue_products',
                isPercent: false,
                hintText: 'Выручка за товары в указанном промежутке (с учетом всех скидок).',
            },
            {
                name: 'Упущенная выручка',
                key: 'lost_revenue',
                isPercent: false,
                hintText: 'Выручка по визитам, которые не состоялись (без перезаписи).',
            },
            {
                name: 'Новые клиенты',
                key: 'new_clients',
                isPercent: false,
                hintText:
                    'Количество клиентов, которые пришли в указанном промежутке, и до этого ни разу не были в этой студии.',
            },
            {
                name: 'Повторные клиенты',
                key: 'old_clients',
                isPercent: false,
                hintText:
                    'Количество клиентов, которые пришли в указанном промежутке, и до этого уже были в этой студии.',
            },
            {
                name: 'Средний чек',
                key: 'avg_check',
                isPercent: false,
                hintText: 'Оборот делим на количество состоявшихся визитов.',
            },
            {
                name: 'Конверсия в доходимость',
                key: 'conversion_att',
                isPercent: true,
                hintText:
                    'Количество состоявшихся визитов делим на количество состоявшихся и отмененных (без перезаписи) визитов.',
            },
            {
                name: 'Возвращаемость за предыдущие 240 дней',
                key: 'return_240',
                isPercent: true,
                hintText:
                    'Чтобы рассчитать возвращаемость по всей сети, мы сначала складываем количество клиентов, которые были в каждом из проектов за предыдущий период (предыдущий период, это либо 240 дней, либо всё предыдущее время). Затем для каждого из проектов мы находим количество клиентов, которые в предыдущем периоде были в этом проекте, а потом вернулись в заданный период (заданный период, это тот, по которому мы в конкретный момент смотрим отчет). Затем сумму вернувшихся клиентов делим на сумму клиентов, которые были в предыдущем периоде и получаем показатель. Т.е., можно сказать, что здесь находится среднее значение показателей по филиалам.\n\nЧтобы рассчитать возвращаемость по конкретному проекту, мы точно так же складываем клиентов, которые были в этом филиале за предыдущий период. Затем складываем клиентов, которые были в предыдущем периоде в конкретном проекте и вернулись в заданном периоде в этот же проект. Потом делим количество вернувшихся на количество тех, которые были в предыдущем.\n\nЧтобы рассчитать возвращаемость по конкретному мастеру, мы подсчитываем клиентов, которые были у этого мастера в предыдущий период. Затем подсчитываем количество тех, которые были у этого мастера в предыдущий период, а потом вернулись к нему же в заданном периоде. Потом делим количество вернувшихся на количество тех, кто был в предыдущем.',
            },
            {
                name: 'Возвращаемость за весь период ',
                key: 'return_all_time',
                isPercent: true,
                hintText:
                    'Чтобы рассчитать возвращаемость по всей сети, мы сначала складываем количество клиентов, которые были в каждом из проектов за предыдущий период (предыдущий период, это либо 240 дней, либо всё предыдущее время). Затем для каждого из проектов мы находим количество клиентов, которые в предыдущем периоде были в этом проекте, а потом вернулись в заданный период (заданный период, это тот, по которому мы в конкретный момент смотрим отчет). Затем сумму вернувшихся клиентов делим на сумму клиентов, которые были в предыдущем периоде и получаем показатель. Т.е., можно сказать, что здесь находится среднее значение показателей по филиалам.\n\nЧтобы рассчитать возвращаемость по конкретному проекту, мы точно так же складываем клиентов, которые были в этом филиале за предыдущий период. Затем складываем клиентов, которые были в предыдущем периоде в конкретном проекте и вернулись в заданном периоде в этот же проект. Потом делим количество вернувшихся на количество тех, которые были в предыдущем.\n\nЧтобы рассчитать возвращаемость по конкретному мастеру, мы подсчитываем клиентов, которые были у этого мастера в предыдущий период. Затем подсчитываем количество тех, которые были у этого мастера в предыдущий период, а потом вернулись к нему же в заданном периоде. Потом делим количество вернувшихся на количество тех, кто был в предыдущем.',
            },
            {
                name: 'ОПЗ другой день',
                key: 'record_other_day',
                isPercent: true,
                hintText:
                    'Складываем всех клиентов, которые приходили в указанном промежутке и у них появилась в этот день запись на будущее (запись может быть и на даты вне указанного промежутка). Делим это на количество клиентов, которые были в указанном промежутке.',
            },
            {
                name: 'ОПЗ тот же день',
                key: 'record_same_day',
                isPercent: true,
                hintText:
                    'Складываем всех клиентов, которые в указанном промежутке пришли по предварительной записи и в этот же день дополнительно посетили другие кабинеты, в которые не были записаны, затем делим это на количество клиентов, которые были по предварительной записи в указанном промежутке.',
            },
            {
                name: 'Сетов в 4 руки',
                key: 'four_hands_service_cnt',
                isPercent: false,
                hintText: 'Количество состоявшихся визитов "сет в 4 руки" за выбранный период.',
            },
            {
                name: 'Количество мастеров, работавших в указанном промежутке',
                key: 'staff_count',
                isPercent: false,
                hintText: 'Сумма всех уникальных мастеров, кто хотя бы 1 раз работал в выбранный период',
            },
            {
                name: 'Среднее количество мастеров в день (номинально)',
                key: 'nominal_mean_staff_cnt',
                reference: 4.4,
                isPercent: false,
                hintText: 'Находим по каждому дню количество мастеров, указанных в расписании, независимо от активных часов. Суммируем. Делим это на количество дней в промежутке.',
            },
            {
                name: 'Среднее количество мастеров в день (если бы каждый мастер имел 12 активных часов)',
                key: 'real_mean_staff_cnt',
                reference: 4.4,
                isPercent: false,
                hintText: 'Сумма всех активных часов за промежуток / количество дней в промежутке / 12.',
            },
            {
                name: 'Суммарное количество активных часов всех мастеров за месяц',
                key: 'active_work_hours',
                reference: 1500,
                isPercent: false,
                hintText: 'Сумма всех активных (белых или цветных без учета серых в YCLIENTS) часов всех мастеров за месяц.',
            },
            {
                name: 'Cреднее количество клиентов на мастера в день',
                key: 'mean_client_on_staff_a_day',
                reference: 3.7,
                isPercent: false,
                hintText: 'Сумма всех сочетаний клиент-мастер-день за промежуток / количество дней в промежутке / среднее количество мастеров в день номинально (т.е. первый показатель)',
            },
            {
                name: 'Выручка в клиентский день',
                key: 'avg_revenue_client_day',
                isPercent: false,
                hintText: 'Выручка в КД (20 число каждого месяца).',
            },
            {
                name: 'Количество мастеров в клиентский день',
                key: 'mean_staff_cnt_client_day',
                isPercent: false,
                hintText: 'Количество мастеров в КД (20 число каждого месяца).',
            },
            {
                name: 'Соотношение выручки КД к обычному дню',
                key: 'revenue_client_day_comparison',
                isPercent: true,
                hintText: 'На сколько выше выручка в КД (20 число каждого месяца) относительно среднедневной выручки в % за выбранный период.',
            },
        ],
        dashboardData: {
            networkData: [] as any[],
            networkDataMean: [] as any[],
            statByFilialData: [] as any[],
            statByFilialDataPrev: [] as any[],
            statByStaffData: [] as any[],
            statByStaffDataPrev: [] as any[],
            statByFilialDataMean: [] as any[],
            statByFilialDataMeanPrev: [] as any[],
            statByFilialComparisonData: [] as any [],
            statByFilialComparisonDataPrev: [] as any []
        },
        graphycsRowData: {
            networkDataMean: [] as any[],
            statByFilialData: [] as any[],
            statByFilialComparisonData: [] as any[],
        }
    }),
    watch: {
        'displayFilters.filialList': {
            immediate: true,
            handler(newVal) {
                if (newVal.length > 0) {
                    const mainFilialId = newVal[0]
                    const currentComparison = this.filters.filialListComparison || {}
                    let hasChanges = false
                    
                    const updatedComparison = { ...currentComparison }
                    
                    Object.keys(updatedComparison).forEach(key => {
                        if (key === mainFilialId && updatedComparison[key].selected) {
                            updatedComparison[key].selected = false
                            hasChanges = true
                        }
                    })
                    
                    if (hasChanges) {
                        this.filters.filialListComparison = updatedComparison
                    }
                }
            }
        },
        hideNetworkColumn: {
            handler(val: boolean) {
                try {
                    localStorage.setItem(this.networkColumnStorageKey, String(val))
                } catch (e) {}
            },
        },

        'displayFilters.filialListComparison': {
            handler(newVal, oldVal) {
                if (newVal.length > 3) {
                    const idsToKeep = newVal.slice(0, 3)
                    const currentComparison = this.filters.filialListComparison || {}
                    const updatedComparison = { ...currentComparison }
                    
                    Object.keys(updatedComparison).forEach(key => {
                        updatedComparison[key].selected = idsToKeep.includes(key)
                    })
                    
                    this.filters.filialListComparison = updatedComparison
                }
            }
        }
    },
    computed: {
        project(): Project {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },

        connector(): Connector | undefined {
            return this.project.connectors.find(el => el.connectorType === CONNECTOR_TYPES.GCB2)
        },
        breadcrumbs(): Array<any> {
            return [
                {
                    text: this.project.name,
                    to: `/project/${this.project.id}`,
                },
                {
                    text: 'Отчет для 4hands',
                    to: '',
                    disabled: true,
                },
            ]
        },
        dateRangeText(): string {
            const formatedDates = this.sortedDates.map(date =>
                moment(date, this.datePickerDateFormat).format(this.dateFormat)
            )
            return formatedDates.join(' - ')
        },
        dateRangeTextForGraphs(): string {
            const formatedDates = this.sortedDatesForGraphs.map(date =>
                moment(date, this.datePickerDateFormat).format(this.dateFormat)
            )
            return formatedDates.join(' - ')
        },
        sortedDates(): string[] {
            return [
                ...this.dates.sort(
                    (a, b) =>
                        moment(a, this.datePickerDateFormat).unix() -
                        moment(b, this.datePickerDateFormat).unix()
                ),
            ]
        },
        sortedDatesForGraphs(): string[] {
            return [
                ...this.datesForGraphs.sort(
                    (a, b) =>
                        moment(a, this.datePickerDateFormat).unix() -
                        moment(b, this.datePickerDateFormat).unix()
                ),
            ]
        },
        displayFilters(): any {
            return {
                staffList: Object.values(this.filters.staffList ?? {})
                    .filter((el: any) => el.selected)
                    .map((el: any) => el.id),
                filialList: Object.values(this.filters.filialList ?? {})
                    .filter((el: any) => el.selected)
                    .map((el: any) => el.id),
                filialListComparison: Object.values(this.filters.filialListComparison ?? {})
                    .filter((el: any) => el.selected)
                    .map((el: any) => el.id),
            }
        },
        queryFilters(): any {
            return pickBy(
                {
                    dateFrom: this.dateHasChanged ? this.sortedDates[0] : undefined,
                    dateTo: this.dateHasChanged ? this.sortedDates[1] : undefined,
                    staffList: this.filters.staffList,
                    filialList: this.filters.filialList,
                    filialListComparison: this.filters.filialListComparison
                },
                (v, k) => {
                    if (isObject(v) && isEmpty(v)) {
                        return false
                    }
                    if (
                        !isNil(v) &&
                        this.displayFilters[k] &&
                        (this.filtersLists[k].length === this.displayFilters[k].length ||
                            this.displayFilters[k].length === 0)
                    ) {
                        return false
                    }
                    return true
                }
            )
        },
        queryFiltersForGraphs(): any {
            return pickBy(
                {
                    dateFrom: this.dateForGraphsHasChanged ? this.sortedDatesForGraphs[0] : undefined,
                    dateTo: this.dateForGraphsHasChanged ? this.sortedDatesForGraphs[1] : undefined,
                    staffList: this.filters.staffList,
                    filialList: this.filters.filialList,
                    filialListComparison: this.filters.filialListComparison
                },
                (v, k) => {
                    if (isObject(v) && isEmpty(v)) {
                        return false
                    }
                    if (
                        !isNil(v) &&
                        this.displayFilters[k] &&
                        (this.filtersLists[k].length === this.displayFilters[k].length ||
                            this.displayFilters[k].length === 0)
                    ) {
                        return false
                    }
                    return true
                }
            )
        },
        isRegionalFilial(): boolean {
            const regionalFilialIds = ['XVL63X5W6', 'X60KN9C5X', 'GXQZDBSZB', 'X3BFUIU2M', 'X3BFUIU2M', 'XGMGTSYUV', 'XA4QO8Q6W', 'NYXYSC7DJ', 'X9FUHP3L5']
            return regionalFilialIds.includes(this.project.id)
        },
        networkColumnStorageKey(): string {
            return `fourhands-report-hide-network-column-${this.project.id}`
        },
        tableData(): { headers: any[]; items: any[] } {
            const HEADER_WIDTH = '120px'
            const d = this.dashboardData
            const baseHeaders: any[] = [
                { text: 'Показатель', value: 'horisontalHeader', sortable: false, width: HEADER_WIDTH },
            ]
            if (!this.hideNetworkColumn) {
                baseHeaders.push({
                    text: this.isRegionalFilial ? 'По региону в целом' : 'По сети в целом',
                    value: 'networkValue',
                    sortable: false,
                    width: HEADER_WIDTH,
                })
            }
            baseHeaders.push(
                {
                    text: this.isRegionalFilial ? 'В среднем по региону' : 'В среднем по сети',
                    value: 'networkDataMean',
                    sortable: false,
                    width: HEADER_WIDTH,
                },
                { text: 'В выбранном филиале', value: 'filialValue', sortable: false, width: HEADER_WIDTH },
                { text: 'В среднем по филиалу', value: 'statByFilialDataMean', sortable: false, width: HEADER_WIDTH }
            )
            const headers = baseHeaders.concat(
                d.statByFilialComparisonData?.map((el: any) => ({
                    text: `${el.project_name || el.original_project_id} (для сравнения)`,
                    value: `filial-comparison-${el.original_project_id}`,
                    sortable: false,
                    width: HEADER_WIDTH,
                }))
            )

            const items = this.valuesKeys.map(el => ({
                horisontalHeader: el.name,
                networkValue: {
                    val: first(d.networkData)?.[el.key] ?? 0,
                    isPercent: el.isPercent,
                },
                networkDataMean: {
                    val: first(d.networkDataMean)?.[el.key] ?? 0,
                    isPercent: el.isPercent,
                },
                filialValue: {
                    val: first(d.statByFilialData)?.[el.key] ?? 0,
                    dynamic: this.getTableValueDynamic('filial', el.key),
                    prevVal: this.getTableValuePrev('filial', el.key),
                    isPercent: el.isPercent,
                    reference: el.reference ?? null,
                },
                statByFilialDataMean: {
                    val: first(d.statByFilialDataMean)?.[el.key] ?? 0,
                    dynamic: this.getTableValueDynamic('filial-mean', el.key),
                    prevVal: this.getTableValuePrev('filial-mean', el.key),
                    isPercent: el.isPercent,
                    reference: el.reference ?? null,
                },
                ...d.statByFilialComparisonData?.reduce(
                    (acc, v) =>
                        Object.assign(acc, {
                            [`filial-comparison-${v.original_project_id}`]: {
                                val: v[el.key] ?? 0,
                                dynamic: this.getTableValueDynamic('filial-comparison', el.key, v.original_project_id),
                                prevVal: this.getTableValuePrev('filial-comparison', el.key, v.original_project_id),
                                isPercent: el.isPercent,
                                reference: el.reference ?? null,
                            },
                        }),
                    {}
                ),
            }))
            return { headers, items }
        },
        filteredfilialListComparison() {
            const mainSelectedFilial = this.displayFilters.filialList[0]
            let baseList = this.filtersLists.filialListComparison?.filter(el => 
                el.id !== mainSelectedFilial
            ) || []
            
            const currentSelectedCount = this.displayFilters.filialListComparison.length
            
            baseList = baseList.map(el => {
                const shouldBeDisabled = currentSelectedCount >= 3 && 
                    !this.displayFilters.filialListComparison.includes(el.id)
                
                return {
                    ...el,
                    disabled: shouldBeDisabled
                }
            })
            
            return baseList
        },
        chartStyles() {
            return {
                height: '400px',
                position: 'relative'
            }
        },
        
        allChartsData() {
            const charts = []
            
            const dateFrom = this.filters.dateFromForGraphs
            const dateTo = this.filters.dateToForGraphs
            
            if (!dateFrom || !dateTo) {
                return charts
            }
            
            const labels = this.getChartLabels(dateFrom, dateTo)

            const filteredNetworkDataMean = this.graphycsRowData.networkDataMean?.filter(el => !isEmpty(el)) || []
            const filteredStatByFilialData = this.graphycsRowData.statByFilialData?.filter(el => !isEmpty(el)) || []
            const filteredStatByFilialComparisonData = this.graphycsRowData.statByFilialComparisonData?.filter(el => !isEmpty(el)) || []

            this.valuesKeys.forEach((metric, index) => {
                const datasets = []
                
                if (filteredStatByFilialData.length > 0) {
                    const filialGroups = this.groupFilialDataByProjectId(filteredStatByFilialData)
                    
                    Object.keys(filialGroups).forEach((projectId, filialIndex) => {
                        const filialGroup = filialGroups[projectId]
                        const filialData = filialGroup.data
                        const projectName = filialGroup.name
                        
                        const filialChartData = this.prepareMetricData(filialData, labels, metric.key)
                        
                        datasets.push({
                            label: projectName,
                            borderColor: '#378EFF',
                            backgroundColor: 'transparent',
                            data: filialChartData,
                            tension: 0.4,
                            borderWidth: 2,
                            pointBackgroundColor: '#378EFF',
                            pointBorderColor: '#ffffff',
                            pointBorderWidth: 2,
                            pointRadius: 4,
                        })
                    })
                }
                
                if (filteredNetworkDataMean.length > 0) {
                    const networkData = this.prepareMetricData(filteredNetworkDataMean, labels, metric.key)
                    datasets.push({
                        label: this.isRegionalFilial ? 'Среднее по региону' : 'Среднее по сети',
                        borderColor: '#FF6384',
                        backgroundColor: 'transparent',
                        data: networkData,
                        tension: 0.4,
                        borderWidth: 2,
                        pointBackgroundColor: '#FF6384',
                        pointBorderColor: '#ffffff',
                        pointBorderWidth: 2,
                        pointRadius: 4,
                    })
                }
                
                if (filteredStatByFilialComparisonData.length > 0) {
                    const comparisonGroups = this.groupFilialDataByProjectId(filteredStatByFilialComparisonData)
                    const colors = ['#4BC0C0', '#FF9F40', '#9966FF', '#FFCD56', '#C9CBCF', '#33FF57', '#3357FF', '#F333FF', '#FF5733']
                    
                    Object.keys(comparisonGroups).forEach((projectId, comparisonIndex) => {
                        const comparisonGroup = comparisonGroups[projectId]
                        const comparisonData = comparisonGroup.data
                        const projectName = comparisonGroup.name
                        
                        const comparisonChartData = this.prepareMetricData(comparisonData, labels, metric.key)
                        
                        datasets.push({
                            label: projectName,
                            borderColor: colors[comparisonIndex % colors.length],
                            backgroundColor: 'transparent',
                            data: comparisonChartData,
                            tension: 0.4,
                            borderWidth: 2,
                            borderDash: comparisonIndex > 4 ? [5, 5] : [],
                            pointBackgroundColor: colors[comparisonIndex % colors.length],
                            pointBorderColor: '#ffffff',
                            pointBorderWidth: 2,
                            pointRadius: 4,
                        })
                    })
                }

                if (datasets.length > 0) {
                    charts.push({
                        title: metric.name,
                        metricKey: metric.key,
                        isPercent: metric.isPercent,
                        hintText: metric.hintText,
                        chartData: {
                            labels,
                            datasets
                        }
                    })
                }
            })

            return charts
        },

        chartOptions() {
            return (isPercent) => ({
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    mode: 'nearest',
                    intersect: true,
                    callbacks: {
                        title: (tooltipItems, data) => {
                            if (tooltipItems && tooltipItems.length > 0) {
                                const label = tooltipItems[0].xLabel || tooltipItems[0].label
                                return this.getFullMonthName(label)
                            }
                            return ''
                        },
                        label: (tooltipItem, data) => {
                            let value = tooltipItem.yLabel || tooltipItem.value || 0
                            const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || ''
                            
                            if (isPercent) {
                                return `${datasetLabel}: ${value}%`
                            } else {
                                if (value >= 1000) {
                                    return `${datasetLabel}: ${new Intl.NumberFormat('ru-RU').format(value)}`
                                } else {
                                    return `${datasetLabel}: ${value}`
                                }
                            }
                        }
                    }
                },
                legend: {
                    labels: {
                        usePointStyle: true,
                    },
                },
                plugins: {
                    datalabels: {
                        display: false,
                    }
                },
                scales: {
                    x: {
                        display: true,
                        title: {
                            display: true,
                            text: 'Период'
                        },
                        grid: {
                            display: false
                        },
                        ticks: {
                            maxRotation: 45,
                            minRotation: 0,
                            autoSkip: true,
                            maxTicksLimit: 8
                        }
                    },
                    y: {
                        display: true,
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: isPercent ? 'Значение, %' : 'Значение'
                        },
                        ticks: {
                            callback: (value) => {
                                if (isPercent) {
                                    return value + '%'
                                } else {
                                    if (value >= 1000) {
                                        return new Intl.NumberFormat('ru-RU').format(value)
                                    }
                                    return value
                                }
                            }
                        }
                    }
                },
                elements: {
                    point: {
                        hoverRadius: 6,
                        hoverBorderWidth: 3
                    }
                },
                hover: {
                    mode: 'nearest',
                    intersect: true
                }
            })
        }
    },
    methods: {
        onDateChange() {
            this.dateHasChanged = true
        },
        onDateChangeForGraphs() {
            this.dateForGraphsHasChanged = true
        },
        setFiltersLists() {
            this.filtersLists = {
                filialList: Object.values(this.filters.filialList ?? {}).map((el: any) => ({
                    id: el.id,
                    name: el.option,
                })),
                filialListComparison: Object.values(this.filters.filialListComparison ?? {}).map((el: any) => ({
                    id: el.id,
                    name: el.option,
                })),
            }
        },
        formatValue(val: any, isPercent: boolean) {
            if (isPercent) return val + '%'
            return new Intl.NumberFormat('ru-RU').format(val).replaceAll(',', '.')
        },
        getTableValueDynamic(type: string, key: string, id?: string) {
            let val, prevVal
            if (type === 'staff') {
                val = this.dashboardData.statByStaffData.find(el => el.staff_id === id)?.[key] ?? 0
                prevVal = this.dashboardData.statByStaffDataPrev.find(el => el.staff_id === id)?.[key] ?? 0
            }
            if (type === 'filial-comparison') {
                val = this.dashboardData.statByFilialComparisonData.find(el => el.original_project_id === id)?.[key] ?? 0
                prevVal = this.dashboardData.statByFilialComparisonDataPrev.find(el => el.original_project_id === id)?.[key] ?? 0
            }
            if (type === 'filial-mean') {
                val = first(this.dashboardData.statByFilialDataMean)?.[key] ?? 0
                prevVal = first(this.dashboardData.statByFilialDataMeanPrev)?.[key] ?? 0
            }
            if (type === 'filial') {
                val = first(this.dashboardData.statByFilialData)?.[key] ?? 0
                prevVal = first(this.dashboardData.statByFilialDataPrev)?.[key] ?? 0
            }
            if (val === prevVal) return null
            if (val > prevVal) return '+'
            if (val < prevVal) return '-'
        },
        getTableValuePrev(type: string, key: string, id?: string) {
            let prevVal
            if (type === 'staff') {
                prevVal = this.dashboardData.statByStaffDataPrev.find(el => el.staff_id === id)?.[key] ?? 0
            }
            if (type === 'filial-comparison') {
                prevVal = this.dashboardData.statByFilialComparisonDataPrev.find(el => el.original_project_id === id)?.[key] ?? 0
            }
            if (type === 'filial-mean') {
                prevVal = first(this.dashboardData.statByFilialDataMeanPrev)?.[key] ?? 0
            }
            if (type === 'filial') {
                prevVal = first(this.dashboardData.statByFilialDataPrev)?.[key] ?? 0
            }
            return prevVal
        },
        dropFilters() {
            this.filters = Object.assign({}, this.inititalFilters)
            this.dateHasChanged = false
            this.dateForGraphsHasChanged = false
            this.firstInited = false
            this.initData()
        },
        isObject,
        isNil,
        setFilterValue(filterId: string, val: any) {
            const updatedFilterVal = {}
            const selectedHmap = val.reduce((a: any, c: any) => Object.assign(a, { [c]: true }), {})
            
            let selectedValues = val
            
            if (filterId === 'filialListComparison') {
                const mainFilialId = this.displayFilters.filialList[0]
                
                selectedValues = val.filter(id => id !== mainFilialId)
                
                if (selectedValues.length > 3) {
                    selectedValues = selectedValues.slice(0, 3)
                    this.$store.dispatch('callNotify', 'Можно выбрать не более 3 филиалов для сравнения')
                }
            }
            
            const finalSelectedHmap = selectedValues.reduce((a: any, c: any) => Object.assign(a, { [c]: true }), {})
            
            this.filtersLists[filterId].forEach((el: any) => {
                const selected = Boolean(finalSelectedHmap[el.id])
                
                setWith(
                    updatedFilterVal,
                    [el.id],
                    {
                        id: el.id,
                        option: el.name,
                        selected: selected,
                        service_group: el.service_group,
                    },
                    Object
                )
            })
            
            this.filters = Object.assign({}, this.filters, { [filterId]: updatedFilterVal })
        },
        setDates() {
            this.dates = [this.filters.dateFrom, this.filters.dateTo]
            this.datesForGraphs = [this.filters.dateFromForGraphs, this.filters.dateToForGraphs]
        },
        async initData(refresh?: boolean) {
            this.dashboardDataLoading = true
            
            const graphsDateFrom = this.datesForGraphs[0] || this.filters.dateFromForGraphs
            const graphsDateTo = this.datesForGraphs[1] || this.filters.dateToForGraphs
            
            const { data, error } = await api.gcb2.getFourHandsReportData({
                projectId: this.project.id,
                filters: this.queryFilters,
                refresh,
            })
            const { data: data2, error: error2 } = await api.gcb2.getFourHandsGraphsData({
                projectId: this.project.id,
                filters: this.queryFiltersForGraphs,
                refresh,
            })
            
            if (error || error2) {
                this.$store.dispatch('callNotify', 'Ошибка')
            }
            
            this.dashboardData = data?.reportData ?? {}
            this.graphycsRowData = data2?.reportData
            
            if(!this.firstInited) {
                this.filters = Object.assign({}, this.filters, data?.filters, {
                    dateToForGraphs: data2?.filters?.dateTo,
                    dateFromForGraphs: data2?.filters?.dateFrom,
                    filialListComparison: data2?.filters?.filialListComparison
                })
                this.setDates()
                this.firstInited = true
            } else {
                if (this.dateForGraphsHasChanged && graphsDateFrom && graphsDateTo) {
                    this.filters.dateFromForGraphs = graphsDateFrom
                    this.filters.dateToForGraphs = graphsDateTo
                }
            }
            
            this.setFiltersLists()
            this.dateHasChanged = false
            this.dateForGraphsHasChanged = false
            this.dashboardDataLoading = false
            
            // Применяем стили для sticky header после обновления данных
            this.applyStickyHeaderStyles()
        },
        getHeaderDescription(header: string) {
            return this.valuesKeys.find(el => el.name === header)?.hintText || ''
        },
        getValueStyle(cell: any) {
            const baseStyle: any = {}
            if (!cell || cell.reference == null || cell.val == null) {
                return baseStyle
            }
            const valNum = Number(cell.val)
            const refNum = Number(cell.reference)
            if (isNaN(valNum) || isNaN(refNum)) {
                return baseStyle
            }
            if (valNum > refNum) {
                return { ...baseStyle, color: '#4CAF50' }
            }
            if (valNum < refNum) {
                return { ...baseStyle, color: '#E20029' }
            }
            return baseStyle
        },
        async exportToExcel() {
            try {
                const [{ default: XLSX }, { default: XLSXStyle }] = await Promise.all([
                    import('xlsx'),
                    import('xlsx-js-style'),
                ])
                const tableData = this.tableData
                const headers = tableData.headers.map(h => h.text)
                
                // Получаем название выбранного филиала
                const selectedFilialId = this.displayFilters.filialList[0]
                let filialName = 'филиал'
                
                // Сначала ищем в filters.filialList
                const selectedFilial = Object.values(this.filters.filialList ?? {}).find(
                    (el: any) => el.id === selectedFilialId
                ) as any
                
                if (selectedFilial) {
                    filialName = selectedFilial.option || selectedFilial.name || filialName
                } else {
                    // Если не найдено, ищем в filtersLists.filialList
                    const filialFromList = this.filtersLists.filialList?.find(
                        (el: any) => el.id === selectedFilialId
                    ) as any
                    if (filialFromList) {
                        filialName = filialFromList.name || filialFromList.option || filialName
                    }
                }
                
                // Подготавливаем данные для экспорта (только числа, без стрелочек и без второго числа за предыдущий год)
                const exportData: any[][] = []
                
                // Добавляем первую строку с названием филиала
                const titleRow: any[] = []
                titleRow.push(`Отчет для ${filialName}`)
                // Остальные ячейки в первой строке пустые
                for (let i = 1; i < headers.length; i++) {
                    titleRow.push('')
                }
                exportData.push(titleRow)
                
                // Добавляем пустую строку для разделения
                exportData.push(new Array(headers.length).fill(''))
                
                // Добавляем заголовки
                exportData.push(headers)
                
                // Добавляем строки данных - для каждого показателя создаем две строки
                tableData.items.forEach((item, itemIndex) => {
                    const indicatorName = item.horisontalHeader || ''
                    const valueKey = this.valuesKeys[itemIndex]

                    // Строка с текущими значениями
                    const currentRow: any[] = []
                    currentRow.push(indicatorName) // Название показателя

                    headers.forEach((header, index) => {
                        const headerValue = tableData.headers[index].value
                        if (headerValue === 'horisontalHeader') {
                            // Уже добавили название показателя
                            return
                        }

                        const cellValue = item[headerValue]
                        if (this.isObject(cellValue) && 'val' in cellValue) {
                            // Берем текущее значение
                            const val = (cellValue as any).val ?? 0
                            const numVal = typeof val === 'string' ? parseFloat(val) || 0 : val
                            currentRow.push(numVal)
                        } else {
                            const val = cellValue || ''
                            if (typeof val === 'number' || (typeof val === 'string' && !isNaN(parseFloat(val)) && val !== '')) {
                                currentRow.push(typeof val === 'number' ? val : parseFloat(val))
                            } else {
                                currentRow.push(val)
                            }
                        }
                    })
                    exportData.push(currentRow)

                    // Строка со значениями за предыдущий год
                    const prevRow: any[] = []
                    prevRow.push(indicatorName + ' (прошлый период)') // Название показателя с пометкой

                    headers.forEach((header, index) => {
                        const headerValue = tableData.headers[index].value
                        if (headerValue === 'horisontalHeader') {
                            // Уже добавили название показателя
                            return
                        }

                        const cellValue = item[headerValue]
                        if (this.isObject(cellValue) && 'prevVal' in cellValue) {
                            const prevVal = (cellValue as any).prevVal
                            if (prevVal !== undefined && prevVal !== null) {
                                // Берем значение за предыдущий год
                                const numVal = typeof prevVal === 'string' ? parseFloat(prevVal) || 0 : prevVal
                                prevRow.push(numVal)
                            } else {
                                // Если нет значения за предыдущий год, оставляем пустую ячейку
                                prevRow.push('')
                            }
                        } else {
                            // Если нет значения за предыдущий год, оставляем пустую ячейку
                            prevRow.push('')
                        }
                    })

                    // Добавляем строку за предыдущий год только если есть хотя бы одно значение
                    const hasPrevValues = prevRow.some((val, idx) => idx > 0 && val !== '')
                    if (hasPrevValues) {
                        exportData.push(prevRow)
                    }

                    // Строка с эталонными значениями
                    const referenceRow: any[] = []
                    referenceRow.push(indicatorName + ' (эталон)') // Название показателя с пометкой

                    headers.forEach((header, index) => {
                        const headerValue = tableData.headers[index].value
                        if (headerValue === 'horisontalHeader') {
                            // Уже добавили название показателя
                            return
                        }

                        const cellValue = item[headerValue]
                        if (this.isObject(cellValue) && 'reference' in cellValue) {
                            const reference = (cellValue as any).reference
                            if (reference !== undefined && reference !== null) {
                                // Берем эталонное значение
                                const numVal = typeof reference === 'string' ? parseFloat(reference) || 0 : reference
                                referenceRow.push(numVal)
                            } else {
                                // Если нет эталонного значения, оставляем пустую ячейку
                                referenceRow.push('')
                            }
                        } else {
                            // Если нет эталонного значения, оставляем пустую ячейку
                            referenceRow.push('')
                        }
                    })

                    // Добавляем строку с эталоном только если есть хотя бы одно значение
                    const hasReferenceValues = referenceRow.some((val, idx) => idx > 0 && val !== '')
                    if (hasReferenceValues) {
                        exportData.push(referenceRow)
                    }
                })
                
                // Создаем рабочую книгу Excel
                const wb = XLSX.utils.book_new()
                const ws = XLSX.utils.aoa_to_sheet(exportData)
                
                // Объединяем ячейки первой строки (заголовок "Отчет для [название филиала]")
                const lastColIndex = headers.length - 1
                if (!ws['!merges']) {
                    ws['!merges'] = []
                }
                ws['!merges'].push({
                    s: { r: 0, c: 0 }, // Начало: строка 0, колонка 0 (A1)
                    e: { r: 0, c: lastColIndex } // Конец: строка 0, последняя колонка
                })
                
                // Настраиваем ширину столбцов
                const colWidths = headers.map(() => ({ wch: 20 }))
                ws['!cols'] = colWidths
                
                // Настраиваем типы данных и выравнивание для всех ячеек
                const range = XLSX.utils.decode_range(ws['!ref'] || 'A1')
                
                // Проходим по всем ячейкам и устанавливаем правильный тип данных
                for (let R = range.s.r; R <= range.e.r; ++R) {
                    for (let C = range.s.c; C <= range.e.c; ++C) {
                        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C })
                        if (!ws[cellAddress]) continue
                        
                        // Для первой строки (R=0) - "Отчет для [название филиала]"
                        if (R === 0) {
                            const cell = ws[cellAddress]
                            cell.t = 's' // тип string
                            cell.s = {
                                alignment: { horizontal: 'left', vertical: 'center' },
                                font: { bold: true, sz: 14 }
                            }
                        } 
                        // Для второй строки (R=1) - пустая строка, пропускаем стилизацию
                        else if (R === 1) {
                            // Пустая строка, оставляем как есть
                        }
                        // Для третьей строки (R=2) - заголовки таблицы
                        else if (R === 2) {
                            const cell = ws[cellAddress]
                            cell.t = 's' // тип string
                            cell.s = {
                                alignment: { horizontal: C === 0 ? 'left' : 'center', vertical: 'center' },
                                font: { bold: true }
                            }
                        } 
                        // Для первой колонки (названия показателей) в строках данных
                        else if (C === 0) {
                            const cell = ws[cellAddress]
                            const cellValue = cell.v
                            // Для строк с "прошлый период" - серый цвет
                            const indicatorName = (cellValue || '').toString()
                            if (indicatorName.includes('(прошлый период)')) {
                                cell.t = 's' // тип string
                                cell.s = {
                                    alignment: { horizontal: 'left', vertical: 'center' },
                                    font: { color: { rgb: "808080" } } // Серый цвет
                                }
                            } else {
                                cell.t = 's' // тип string
                                cell.s = {
                                    alignment: { horizontal: 'left', vertical: 'center' }
                                }
                            }
                        } 
                        // Для остальных колонок в строках данных
                        else {
                            // Для числовых колонок - устанавливаем тип числа, формат и выравнивание
                            const cell = ws[cellAddress]
                            const cellValue = cell.v
                            
                            // Если значение - число, устанавливаем тип, формат и выравнивание по правому краю
                            if (typeof cellValue === 'number' || (typeof cellValue === 'string' && !isNaN(parseFloat(cellValue)) && cellValue !== '')) {
                                // Убеждаемся, что значение сохранено как число
                                let numValue: number
                                if (typeof cellValue === 'string') {
                                    numValue = parseFloat(cellValue)
                                } else {
                                    numValue = cellValue
                                }
                                cell.v = numValue
                                cell.t = 'n' // тип number
                                
                                // Определяем, является ли показатель процентным
                                // Получаем название показателя из первой колонки текущей строки
                                const indicatorNameCell = ws[XLSX.utils.encode_cell({ r: R, c: 0 })]
                                const indicatorName = indicatorNameCell?.v || ''

                                // Находим соответствующий показатель в valuesKeys
                                // Убираем "(прошлый период)" и "(эталон)" из названия, если есть
                                const cleanName = indicatorName.toString()
                                    .replace(' (прошлый период)', '')
                                    .replace(' (эталон)', '')
                                const valueKey = this.valuesKeys.find(vk => vk.name === cleanName)
                                const isPercent = valueKey?.isPercent || false

                                // Устанавливаем формат в зависимости от типа показателя
                                if (isPercent) {
                                    // Для процентных показателей - процентный формат
                                    // Значение уже в процентах (например, 50 для 50%), поэтому делим на 100 для Excel
                                    cell.v = numValue / 100
                                    cell.z = '0.00%' // процентный формат с двумя знаками после запятой
                                } else {
                                    // Проверяем, является ли число целым
                                    const isInteger = numValue % 1 === 0

                                    // Устанавливаем формат числа: для целых чисел без запятой, для дробных - с запятой
                                    if (isInteger) {
                                        cell.z = '#,##0' // формат для целых чисел без дробной части
                                    } else {
                                        cell.z = '#,##0.##' // формат с разделителями тысяч, знаки после запятой только если не нулевые
                                    }
                                }
                                
                                // Устанавливаем выравнивание по правому краю (только для xlsx-js-style)
                                cell.s = {
                                    alignment: { horizontal: 'right', vertical: 'center' }
                                }
                            } else {
                                // Для текстовых значений (не числа) - по правому краю
                                cell.t = 's' // тип string
                                cell.s = {
                                    alignment: { horizontal: 'right', vertical: 'center' }
                                }
                            }
                        }
                    }
                }
                
                // Добавляем лист в книгу
                XLSX.utils.book_append_sheet(wb, ws, 'Отчет')
                
                // Формируем имя файла с названием филиала и датами
                const dateFrom = this.filters.dateFrom || this.filters.date_from || ''
                const dateTo = this.filters.dateTo || this.filters.date_to || ''
                const dateStr = dateFrom && dateTo 
                    ? `_${moment(dateFrom).format('DD.MM.YYYY')}-${moment(dateTo).format('DD.MM.YYYY')}`
                    : ''
                // Очищаем название филиала от недопустимых символов для имени файла
                const safeFilialName = filialName.replace(/[<>:"/\\|?*]/g, '_').substring(0, 50)
                const fileName = `Отчет_4hands_${safeFilialName}${dateStr}_${moment().format('DD.MM.YYYY')}.xlsx`
                
                // Сохраняем файл с поддержкой стилей
                XLSXStyle.writeFile(wb, fileName)
            } catch (error) {
                console.error('Ошибка экспорта в Excel:', error)
                this.$store.dispatch('callNotify', 'Ошибка экспорта в Excel')
            }
        },
        groupFilialDataByProjectId(filialData) {
            const groups = {}
            
            if (!Array.isArray(filialData)) {
                console.error('groupFilialDataByProjectId: filialData is not an array', filialData)
                return groups
            }
            
            filialData.forEach(item => {
                if (!item || !item.original_project_id) return
                
                const projectId = item.original_project_id
                const projectName = item.project_name || projectId

                if (!groups[projectId]) {
                    groups[projectId] = {
                        data: [],
                        name: projectName
                    }
                }
                groups[projectId].data.push(item)
            })
            
            return groups
        },
        
        prepareMetricData(dataArray, labels, metricKey) {
            return labels.map(label => {
                const monthData = dataArray.find(item => {
                    if (!item || !item.month_start) return false
                    const itemMonth = moment(item.month_start).format('MMM YYYY')
                    return itemMonth === label
                })
                
                if (monthData && monthData[metricKey] !== null && monthData[metricKey] !== undefined) {
                    return monthData[metricKey]
                }
                return 0
            })
        },
        
        getAllMonthsBetweenPeriod(dateFrom, dateTo) {
        if (!dateFrom || !dateTo) return []
        
        const dateStart = moment(dateFrom)
        const dateEnd = moment(dateTo)
        const months = []
        
        const monthDiff = dateEnd.diff(dateStart, 'months')
        
        let format, step
        
        if (monthDiff <= 6) {
            format = 'MMM YYYY'
            step = 1
        } else if (monthDiff <= 24) {
            format = 'MMM YYYY'
            step = 3
        } else if (monthDiff <= 60) {
            format = 'MMM YYYY'
            step = 6
        } else {
            format = 'YYYY'
            step = 12
        }

        let currentDate = dateStart.clone()
        let lastAddedMonth = null
        
        while (currentDate.isBefore(dateEnd) || currentDate.isSame(dateEnd, 'month')) {
            const currentMonth = currentDate.format('MMM YYYY')
            const currentYear = currentDate.format('YYYY')
            
            let shouldAdd = false
            
            if (step === 1) {
                shouldAdd = true
            } else if (format === 'YYYY') {
                if (lastAddedMonth === null || currentDate.month() === 0) {
                    shouldAdd = true
                }
            } else {
                if (lastAddedMonth === null || 
                    (currentDate.month() - lastAddedMonth.month() + 
                     (currentDate.year() - lastAddedMonth.year()) * 12) >= step) {
                    shouldAdd = true
                }
            }
            
            if (shouldAdd) {
                months.push(currentDate.format(format))
                lastAddedMonth = currentDate.clone()
            }
            
            currentDate.add(1, 'month')
        }

        const lastDateFormatted = dateEnd.format(format)
        if (months.length === 0 || months[months.length - 1] !== lastDateFormatted) {
            months.push(lastDateFormatted)
        }

        return months
    },
    
        getAdaptiveMonthsLabels(dateFrom, dateTo) {
            if (!dateFrom || !dateTo) return []
            
            const dateStart = moment(dateFrom)
            const dateEnd = moment(dateTo)
            const allMonths = []
            
            let current = dateStart.clone()
            while (current.isBefore(dateEnd) || current.isSame(dateEnd, 'month')) {
                allMonths.push({
                    date: current.clone(),
                    formatted: current.format('MMM YYYY'),
                    month: current.month(),
                    year: current.year()
                })
                current.add(1, 'month')
            }
            
            if (allMonths.length <= 12) {
                return allMonths.map(m => m.formatted)
            }
            
            const maxLabels = 12
            const step = Math.ceil(allMonths.length / maxLabels)
            
            const filteredMonths = allMonths.filter((_, index) => index % step === 0)
            
            if (filteredMonths.length > 0) {
                const firstMonth = allMonths[0].formatted
                const lastMonth = allMonths[allMonths.length - 1].formatted
                
                if (!filteredMonths.includes(firstMonth)) {
                    filteredMonths.unshift(firstMonth)
                }
                if (!filteredMonths.includes(lastMonth)) {
                    filteredMonths.push(lastMonth)
                }
            }
            
            return filteredMonths.map(m => typeof m === 'string' ? m : m.formatted)
        },
        
        getChartLabels(dateFrom, dateTo) {
            if (!dateFrom || !dateTo) return []
            
            const start = moment(dateFrom)
            const end = moment(dateTo)
            const monthDiff = end.diff(start, 'months')
            
            if (monthDiff <= 24) {
                const labels = []
                let current = start.clone()
                const seen = new Set()
                
                while (current.isBefore(end) || current.isSame(end, 'month')) {
                    const label = current.format('MMM YYYY')
                    if (!seen.has(label)) {
                        labels.push(label)
                        seen.add(label)
                    }
                    current.add(1, 'month')
                }
                return labels
            }
            
            const maxLabels = 15
            const step = Math.ceil(monthDiff / maxLabels)
            
            const labels = []
            let current = start.clone()
            const seen = new Set()
            
            const firstLabel = current.format('MMM YYYY')
            labels.push(firstLabel)
            seen.add(firstLabel)
            
            let count = 0
            while (current.isBefore(end)) {
                current.add(1, 'month')
                count++
                
                if (count % step === 0 || current.isSame(end, 'month')) {
                    const label = current.format('MMM YYYY')
                    if (!seen.has(label)) {
                        labels.push(label)
                        seen.add(label)
                    }
                }
            }
            
            return labels
        },
        
        hasChartData() {
            return this.allChartsData && this.allChartsData.length > 0 && 
                this.allChartsData.some(chart => chart.chartData.datasets.length > 0)
        },
        getFullMonthName(shortMonthName) {
            const monthMap = {
                'Jan': 'Январь',
                'Feb': 'Февраль', 
                'Mar': 'Март',
                'Apr': 'Апрель',
                'May': 'Май',
                'Jun': 'Июнь',
                'Jul': 'Июль',
                'Aug': 'Август',
                'Sep': 'Сентябрь',
                'Oct': 'Октябрь',
                'Nov': 'Ноябрь',
                'Dec': 'Декабрь'
            }
            
            const parts = shortMonthName.split(' ')
            if (parts.length === 2 && monthMap[parts[0]]) {
                return `${monthMap[parts[0]]} ${parts[1]}`
            }
            
            return shortMonthName
        },
        applyStickyHeaderStyles() {
            this.$nextTick(() => {
                const tableWrapper = this.$refs.tableWrapper as HTMLElement
                if (!tableWrapper) return
                
                const table = tableWrapper.querySelector('#fourhands-report-table')
                if (!table) return
                
                const wrapper = table.querySelector('.v-data-table__wrapper') as HTMLElement
                if (!wrapper) return
                
                // Убеждаемся, что wrapper не имеет overflow, который мешает sticky
                wrapper.style.overflow = 'visible'
                wrapper.style.maxHeight = 'none'
                
                const thead = wrapper.querySelector('table thead')
                if (!thead) return
                
                const ths = thead.querySelectorAll('th')
                ths.forEach((th: HTMLElement) => {
                    th.style.position = 'sticky'
                    th.style.top = '0'
                    th.style.zIndex = '10'
                    th.style.background = '#f4f4f4'
                    th.style.boxShadow = '0 2px 2px -1px rgba(0, 0, 0, 0.1)'
                })
            })
        }
        
    },
    async mounted() {
        this.inititalFilters = Object.assign({}, this.filters)
        this.pageLoading = true

        try {
            const stored = localStorage.getItem(this.networkColumnStorageKey)
            if (stored !== null) {
                this.hideNetworkColumn = stored === 'true'
            }
        } catch (e) {}

        await this.initData(false)
        this.pageLoading = false
        
        // Применяем стили для sticky header после загрузки данных
        this.applyStickyHeaderStyles()
    },
})
